export default __webpack_public_path__ + "static/media/games-banner.5e56a7d2.webp";